module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.ce305bb.woff2";